/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardInscriptionGridDto } from './DashboardInscriptionGridDto';
import {
    DashboardInscriptionGridDtoFromJSON,
    DashboardInscriptionGridDtoFromJSONTyped,
    DashboardInscriptionGridDtoToJSON,
} from './DashboardInscriptionGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardInscriptionGridDtoPaginatedResults
 */
export interface DashboardInscriptionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardInscriptionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardInscriptionGridDto>}
     * @memberof DashboardInscriptionGridDtoPaginatedResults
     */
    results?: Array<DashboardInscriptionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardInscriptionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardInscriptionGridDtoPaginatedResults interface.
 */
export function instanceOfDashboardInscriptionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardInscriptionGridDtoPaginatedResultsFromJSON(json: any): DashboardInscriptionGridDtoPaginatedResults {
    return DashboardInscriptionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardInscriptionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardInscriptionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardInscriptionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardInscriptionGridDtoPaginatedResultsToJSON(value?: DashboardInscriptionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardInscriptionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

